export default __webpack_public_path__ + "static/guest-c39eeed7c0d835159f37562111cd2c99.png";